"use client";

import React from "react";
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
const services = [{
  title: "Emergency Service",
  path: "/GoldGarageDoorEmergencyServiceAndRepairPage"
}, {
  title: "Spring Replacement",
  path: "/GarageDoorSpringReplacementSydneyPage"
}, {
  title: "Motor Repair",
  path: "/GarageDoorMotorRepairSydneyPage"
}, {
  title: "New Installation",
  path: "/GarageDoorInstallationSydneyPage"
}, {
  title: "Cable Repair",
  path: "/GarageDoorCableRepairSydneyPage"
}];
const contactInfo = [{
  icon: Phone,
  text: "1300 000 000",
  href: "tel:1300000000"
}, {
  icon: Mail,
  text: "info@goldgaragedoor.com.au",
  href: "mailto:info@goldgaragedoor.com.au"
}, {
  icon: MapPin,
  text: "Sydney, NSW, Australia",
  href: "#"
}];
const socials = [{
  icon: Facebook,
  label: "Facebook",
  href: "#"
}, {
  icon: Twitter,
  label: "Twitter",
  href: "#"
}, {
  icon: Instagram,
  label: "Instagram",
  href: "#"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i} className="h-5 w-24 bg-muted animate-pulse rounded-md" />)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/OurServicesPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Our Services
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/GalleryPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Gallery
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/ServiceAreasPage" className="text-muted-foreground hover:text-primary transition-colors text-sm">
            Service Areas
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors text-sm">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section id="footer" className="bg-background text-foreground pt-16 pb-8 border-t border-border">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          
          {}
          <div className="flex flex-col gap-6">
            <Link to="/" className="inline-block">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <p className="text-muted-foreground text-sm leading-relaxed">
              Providing top-quality garage door repair, maintenance, and installation services across Sydney. Available 24/7 for emergency repairs to keep your home secure.
            </p>
            <div className="flex gap-3">
              {socials.map((social, i) => {
              const Icon = social.icon;
              return <Button key={social.label} data-index={i} variant="outline" size="icon" asChild className="rounded-lg">
                    <Link to={social.href} aria-label={social.label}>
                      <Icon className="size-4" />
                    </Link>
                  </Button>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6">Quick Links</h3>
            <MenuProvider menu_id="16">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6">Our Services</h3>
            <ul className="flex flex-col gap-3">
              {services.map((service, i) => <li key={service.title} data-index={i}>
                  <Link to={service.path} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                    {service.title}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-semibold text-lg mb-6">Contact Us</h3>
            <ul className="flex flex-col gap-4">
              {contactInfo.map((info, i) => {
              const Icon = info.icon;
              return <li key={info.text} data-index={i} className="flex items-start gap-3">
                    <Icon className="size-5 text-primary shrink-0 mt-0.5" />
                    <Link to={info.href} className="text-muted-foreground hover:text-primary transition-colors text-sm">
                      {info.text}
                    </Link>
                  </li>;
            })}
            </ul>
          </div>

        </div>

        <Separator className="mb-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-muted-foreground">
          <p>© {new Date().getFullYear()} Gold Garage Door. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-primary transition-colors">Privacy Policy</Link>
            <Link to="#" className="hover:text-primary transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </section>;
}